if (!customElements.get('product-form')) {
  function goToCart()
  {
    window.location.href = 'https://preworn.ltd/cart';
  }
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => 
        {
          console.log(response);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          addToCartOk(response);
          
         
          async function addToCartOk(product) 
          {
            var emptycart =  document.getElementById("emptycartfiller");
              if (emptycart) {
                  document.getElementById("emptycartfiller").remove();
              }
            console.log( document.getElementsByClassName('preworn-flex-container')[0]);
            console.log( product );
            var cartitemlink = document.createElement('div');
            cartitemlink.classList.add("sidebar-cart-item");

            const price =  (product.line_price/100);

            
            function formatMoney(number) {
              number = number.toFixed(2);
              const valueArray = number.split(".");
              console.log(valueArray);
                var strNumber = '<span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem; position: relative; margin-right: 0px;color: #000;" class="poundSignSide">£</span><span style="font-weight: bold; font-size: 3rem; position: relative; margin-right: 1px;color: #000;" class="poundActualSide">';
                strNumber = strNumber.concat(valueArray[0]);
                strNumber = strNumber.concat('</span> <span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem;margin-left: -2px; position: relative; margin-right: 0px;color: #000; class="poundActualSide">');
                strNumber = strNumber.concat(valueArray[1]);
                strNumber = strNumber.concat("</span>");
                return strNumber;
              }
               
              
              var cartTotal = await getCart();
              function getCart() 
              {
                $.ajax({
                  type: 'GET', 
                   url: '/cart.js',
                   success: function(data)
                   {
                      iCartTotal = 0;
                      console.log(data);
                      var incoming = JSON.parse(data);
                      var arrayCartItems = incoming.items;
                      var arrayLength = arrayCartItems.length;

                      for (var i = 0; i < arrayLength; i++) 
                      {
                        iCartTotal = iCartTotal + arrayCartItems[i].original_price;
                      }
                      

                      var iCartTotalTemp  = iCartTotal/100;
                      var cartLoyalty = document.getElementById('cartLoyaltyTotal');
                      var loyaltyPrice = iCartTotalTemp * 0.25;
                      loyaltyPrice = loyaltyPrice.toFixed(2);
                      cartLoyalty.innerHTML = "LOYALTY: £" + loyaltyPrice + " OFF Your Next Order";
            
                      var cartFreeShipping = document.getElementById('cartFreeShippingOff');
                      var cartFreeShippingPrice = 20-iCartTotalTemp;
                      if(iCartTotalTemp < 0)
                      {
                        cartFreeShippingPrice = cartFreeShippingPrice.toFixed(2);
                        cartFreeShipping.style.background = "#ff8000";
                        cartFreeShipping.innerHTML = "Get Free Shipping: Add Item to Basket";
                      }
                      else
                      {
                        cartFreeShipping.style.background = "Green";
                        cartFreeShipping.innerHTML = "You Have Earnt FREE Shipping";
                      }

                      var cartSideBarPrice = document.getElementById('cartSideBarPrice');
              
                      var priceHTML = formatMoney(iCartTotalTemp);
                      cartSideBarPrice.innerHTML = priceHTML;
                      
                      var cart5OffCount = document.getElementById('cart5OffCount');
                      var cart5OffCountPrice = 30-iCartTotalTemp;
                      if(cart5OffCountPrice > 0)
                      {
                        cart5OffCountPrice = cart5OffCountPrice.toFixed(2);
                        cart5OffCount.style.background = "#ff8000";
                        cart5OffCount.innerHTML = "Get £5 OFF: ADD £" + cart5OffCountPrice;
                      }
                      else
                      {
                        cart5OffCount.style.background = "Green";
                        cart5OffCount.innerHTML = "You Have Got £5 OFF Your Order";
                      }

                   },
                   error: function(XMLHttpRequest, textStatus) {
                    console.log(XMLHttpRequest, textStatus);
                  }
                });
              }

                cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ product.image 
                +'"><img class="sidebar-cart-img" src="' + product.image 
                +'" /></a><a class="cart-item-link"  href="'+ product.url 
                +'"><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +product.title 
                +'</p></span><div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
                +'</div><span style="margin-left: 5px; width: fit-content;  position: relative; top: -8px; background-color: green; color: white; padding: 2px 8px 3px 8px; font-size: 1.4rem; border-radius: 6px;">Last One</span></div></a><span class="close-btn" js-preworn-close-modal=""><svg id="'+ product.id +'"class="remove-item-sidebar" width="15" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg></span></div>';
          

            var cartdiv = document.getElementsByClassName('preworn-flex-container')[0];
            cartdiv.appendChild(cartitemlink);
            
            console.log(document.getElementsByClassName('icon-cart-empty').length);
            if(document.getElementsByClassName('icon-cart-empty').length != 0)
            {
              var carticon = document.getElementsByClassName('icon-cart-empty')[0];
              carticon.classList.remove("icon-cart-empty");
              carticon.classList.add("icon-cart");
              var cartcountdiv  = document.createElement('div');
              cartcountdiv.classList.add("cart-count-bubble");
              cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              
              document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
            }

            evt.target.setAttribute('title', 'Remove From Basket');
            jQuery.getJSON('/cart.js', function (cart, textStatus) {
              var carttext="("+cart.item_count +")";
              jQuery(".cart-count-bubble").text(carttext);
              jQuery(".count-cart-sidebar").text(carttext);
            });
    
          } 
          
          
          this.submitButton.classList.add('loading');
          this.submitButton.setAttribute("name", "remove");
          this.submitButton.children[0].innerHTML = "View in Basket";
          this.submitButton.setAttribute('onclick','goToCart()')


        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
if (!customElements.get('product-form')) {
  function goToCart()
  {
    window.location.href = 'https://preworn.ltd/cart';
  }
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => 
        {
          console.log(response);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          addToCartOk(response);
          
         
          async function addToCartOk(product) 
          {
            var emptycart =  document.getElementById("emptycartfiller");
              if (emptycart) {
                  document.getElementById("emptycartfiller").remove();
              }
            console.log( document.getElementsByClassName('preworn-flex-container')[0]);
            console.log( product );
            var cartitemlink = document.createElement('div');
            cartitemlink.classList.add("sidebar-cart-item");

            const price =  (product.line_price/100);

            
            function formatMoney(number) {
              number = number.toFixed(2);
              const valueArray = number.split(".");
              console.log(valueArray);
                var strNumber = '<span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem; position: relative; margin-right: 0px;color: #000;" class="poundSignSide">£</span><span style="font-weight: bold; font-size: 3rem; position: relative; margin-right: 1px;color: #000;" class="poundActualSide">';
                strNumber = strNumber.concat(valueArray[0]);
                strNumber = strNumber.concat('</span> <span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem;margin-left: -2px; position: relative; margin-right: 0px;color: #000; class="poundActualSide">');
                strNumber = strNumber.concat(valueArray[1]);
                strNumber = strNumber.concat("</span>");
                return strNumber;
              }
               
              
              var cartTotal = await getCart();
              function getCart() 
              {
                $.ajax({
                  type: 'GET', 
                   url: '/cart.js',
                   success: function(data)
                   {
                      console.log(data);
                      var incoming = JSON.parse(data);
                      var arrayCartItems = incoming.items;
                      var arrayLength = arrayCartItems.length;

                      var cartSideBarPrice = document.getElementById('cartSideBarPrice');
                      cartTotal =  incoming.original_total_price;
                      cartTotal = cartTotal/100;
                      cartTotal = cartTotal.toFixed(2);
                      const valueArrayTotal = cartTotal.split(".");
                      cartSideBarPrice.innerHTML ='<span class="poundSignSide">£</span><span class="poundActualSide">' +valueArrayTotal[0]
                      +'</span> <span class="penceActualSide">' + valueArrayTotal[1]
                      +'</span></span>';

                   } ,
                   error: function(XMLHttpRequest, textStatus) {
                    console.log(XMLHttpRequest, textStatus);
                  }
                });
              }

                cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ product.image 
                +'"><img class="sidebar-cart-img" src="' + product.image 
                +'" /></a><a class="cart-item-link"  href="'+ product.url 
                +'"><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +product.title 
                +'</p></span><div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
                +'</div><span style="margin-left: 5px; width: fit-content;  position: relative; top: -8px; background-color: green; color: white; padding: 2px 8px 3px 8px; font-size: 1.4rem; border-radius: 6px;">Last One</span></div></a><span class="close-btn" js-preworn-close-modal=""><svg id="'+ product.id +'"class="remove-item-sidebar" width="15" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg></span></div>';
          

            var cartdiv = document.getElementsByClassName('preworn-flex-container')[0];
            cartdiv.appendChild(cartitemlink);
            
            console.log(document.getElementsByClassName('icon-cart-empty').length);
            if(document.getElementsByClassName('icon-cart-empty').length != 0)
            {
              var carticon = document.getElementsByClassName('icon-cart-empty')[0];
              carticon.classList.remove("icon-cart-empty");
              carticon.classList.add("icon-cart");
              var cartcountdiv  = document.createElement('div');
              cartcountdiv.classList.add("cart-count-bubble");
              cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              
              document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
            }

            evt.target.setAttribute('title', 'Remove From Basket');
            jQuery.getJSON('/cart.js', function (cart, textStatus) {
              var carttext="("+cart.item_count +")";
              jQuery(".cart-count-bubble").text(carttext);
              jQuery(".count-cart-sidebar").text(carttext);
            });
    
          } 
          
          
          this.submitButton.classList.add('loading');
          this.submitButton.setAttribute("name", "remove");
          this.submitButton.children[0].innerHTML = "View in Basket";
          this.submitButton.setAttribute('onclick','goToCart()')


        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
